import { render, staticRenderFns } from "./PublicContent.vue?vue&type=template&id=0c4ee7b1&scoped=true&"
import script from "./PublicContent.vue?vue&type=script&lang=js&"
export * from "./PublicContent.vue?vue&type=script&lang=js&"
import style0 from "./PublicContent.vue?vue&type=style&index=0&id=0c4ee7b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ee7b1",
  null
  
)

export default component.exports